<template>
	<section class="app-main">
		<transition name="fade-transform" mode="out-in"
			style="box-shadow: rgba(204, 204, 204, 0.35) 18px 10px 8px -15px inset">
			<!-- :include="cachedViews" 动态路由加载数据 -->
			<keep-alive :include="cachedViews">
				<router-view :key="key" />
			</keep-alive>
		</transition>
	</section>
</template>

<script>
	export default {
		name: 'AppMain',
		computed: {
			cachedViews() {
				return this.$store.state.tagsView.cachedViews
			},
			key() {
				return this.$route.path
			}
		}
	}
</script>

<style lang="scss" scoped>
	.app-main {
		/* 50= navbar  50  */
		/* min-height: calc(100vh - 50px); */
		width: 100%;
		position: relative;
		overflow: hidden;
		box-shadow: rgba(204, 204, 204, 0.35) 18px 10px 8px -15px inset;
	}

	.fixed-header+.app-main {
		padding-top: 50px;
	}

	.hasTagsView {
		.app-main {
			/* 84 = navbar + tags-view = 50 + 34 */
			/* min-height: calc(100vh - 84px); */
			background-color: white;
			padding-bottom: 32px;
		}

		.fixed-header+.app-main {
			padding-top: 84px;
		}
	}
</style>

<style lang="scss">
	// fix css style bug in open el-dialog
	.el-popup-parent--hidden {
		.fixed-header {
			padding-right: 15px;
		}
	}

	.el-scrollbar__bar.is-vertical {
		display: none !important;
	}
</style>
